import i18n from "i18next";
import { initReactI18next, useTranslation } from "react-i18next";

import enJSON from "./locale/en-GB.json";
import esJSON from "./locale/es-ES.json";
import mxJSON from "./locale/es-MX.json";
import ptJSON from "./locale/pt-PT.json";

i18n.use(initReactI18next).init({
  resources: {
    ["es-ES"]: { translation: { ...esJSON } },
    ["en-GB"]: { translation: { ...enJSON } },
    ["pt"]: { translation: { ...ptJSON } },
    ["pt-PT"]: { translation: { ...ptJSON } },
    ["pt-BR"]: { translation: { ...ptJSON } },
    ["es-MX"]: { translation: { ...mxJSON } },
  },
  lng: localStorage.getItem("lang") || navigator.language,
  fallbackLng() {
    return "es-ES";
  },
});

const useLang = () => {
  const { i18n } = useTranslation();
  return i18n.language.split("-")[0];
};

const useLocale = () => {
  const { i18n } = useTranslation();
  return i18n.language;
};

export { i18n, useLang, useLocale };
